const MoneyIcon = ({ className, ...props }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M4 6.25H20C21.2426 6.25 22.25 7.25736 22.25 8.5V15.5C22.25 16.7426 21.2426 17.75 20 17.75H4C2.75736 17.75 1.75 16.7426 1.75 15.5V8.5C1.75 7.25736 2.75736 6.25 4 6.25Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <circle cx="12" cy="12" r="2.25" stroke="currentColor" strokeWidth="1.5" />
            <path d="M4.75 12H7.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M16.75 12H19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
    )
}

export default MoneyIcon
